import { Loader, Tooltip } from '@mantine/core'
import { ExternalLink } from 'lucide-react'

import { PackageTypeLabels } from 'src/graphql/types/package'

type Props = {
  orderType: string
  providerOrderId?: string
  isLoadingEnhancedReport?: boolean
  onEnhancedReportClick?: () => void
}

const ProviderCell = ({
  orderType,
  providerOrderId,
  isLoadingEnhancedReport = false,
  onEnhancedReportClick,
}: Props) => {
  return (
    <div className="flex items-center gap-2">
      <span>{PackageTypeLabels[orderType] || orderType}</span>
      {orderType === 'HIRE_RIGHT' && providerOrderId && (
        <Tooltip label="View enhanced report">
          {isLoadingEnhancedReport ? (
            <Loader size={10} color="gray" />
          ) : (
            <ExternalLink
              size={10}
              className="cursor-pointer hover:text-doubleNickel-gray-700"
              onClick={(e) => {
                e.stopPropagation()
                onEnhancedReportClick?.()
              }}
            />
          )}
        </Tooltip>
      )}
    </div>
  )
}

export default ProviderCell
